import React, {VoidFunctionComponent} from "react";

export const InformationSheetLink: VoidFunctionComponent<{ url: string | null }> = ({url}) => {
    if (!url) {
        return null;
    }
    return (
        <div className='information-sheet-link'>
            <a href={url} target='_blank' rel='noopener noreferrer'>
                Fiche d’information sur le produit
            </a>
        </div>
    );
};